// Module
var code = "<react-component name=\"RecurringBookingSummariesReport\"></react-component>\n";
// Exports
module.exports = code;